import * as React from "react";
import { Statisic } from "../../components/Statistic";
import { AUDIO, DOWNLOAD } from "../../assets";
import { BPMAnalyticsAPI, Album, MediaAPI } from "../../api";
import { FilterContextType, FilterParams } from "../../components/context/filter";
import { Route, Switch, Redirect, RouteComponentProps } from "react-router-dom";
import { DownloadChart } from "./charts/DownloadChart";
import { StreamChart } from "./charts/StreamChart";
import { DownloadStatisticChart } from "./charts/DownloadStatisticChart";
import { StreamStatisticChart } from "./charts/StreamStatisticChart";
import { ScrollView } from '../../components/ScrollView'
import { TopCountryChart } from "./charts/TopCountryChart";
import { DownloadedFromChart } from "./charts/DownloadedFromChart";
import { TopStateChart } from "./charts/TopStateChart";
import Loader from "../../components/Loader";
import { Environment } from "../../env";
import { SoundPackage } from "./soundpackage";
import { PlatformRenderer, sp } from "../../utils/platformSelect";
import { APIVersion, AuthenticatedRequest, HTTPMethod } from "api/src/requests/request";

interface StatisticState {
    media: number
    totalDownloads: number
    totalStreams: number
    usersInteracted: number
    totalUsersInteracted: number
}
interface DashboardState {
    statistics?: StatisticState
    album?: Album | { pack: SoundPackage, tagCount: number }
}
class AlbumInner extends React.Component<RouteComponentProps<{ id: string }>, DashboardState> {

    static contextType = FilterContextType

    context: FilterParams
    previousContext: FilterParams;

    constructor(p: any) {
        super(p);
        this.state = {

        }
    }

    componentDidUpdate(prevProps: RouteComponentProps<{ id: string }>) {
        if (this.previousContext !== this.context || this.props.match.params.id != prevProps.match.params.id) {
            this.loadData();
        }
        this.previousContext = this.context;
    }

    componentDidMount() {
        this.previousContext = this.context;
        this.loadData()
    }

    loadData() {
        this.setState({ statistics: undefined })
        BPMAnalyticsAPI.get<StatisticState>('album/statistics', { ...this.context, album: this.props.match.params.id }, undefined).then((stats) => {
            this.setState({ statistics: stats })
        })
        if (this.context.platform == 'create') {
            BPMAnalyticsAPI.get<any>('sound-package/' + this.props.match.params.id, {}, undefined, Environment.CREATE_API).then((album) => {
                this.setState({ album })
            })
        } else {
            const apiRequest = new AuthenticatedRequest<{}>('/album/' + this.props.match.params.id, HTTPMethod.GET, APIVersion.v1_0);
            apiRequest.overrideAPIUrl = `https://api.download.bpmsupreme.com`

            return apiRequest.send().then((response) => {
                this.setState({ album: response.data })
            });
        }
    }

    render() {
        return <div className='dashboard'>
            <div className='statistics'>
                <ScrollView>
                    <PlatformRenderer only={['supreme']}>
                        <Statisic key={9} renderContent={() => {
                            if (!this.state.album) {
                                return <Loader white />
                            }
                            const { album } = this.state as { album: any }
                            return <div className='statistic-info-container'>
                                <div className="field-label">Name</div>
                                <div className="field-value-static">{album.name}</div>
                                <div className="field-label">Artist</div>
                                <div className="field-value-static">{album.artist}</div>
                                <div className="field-label">Category</div>
                                <div className="field-value-static">{album.category.name}</div>
                                <div className="field-label">Genre</div>
                                <div className="field-value-static">{album.genre.name}</div>
                                <div className="field-label">Label</div>
                                <div className="field-value-static">{album.label}</div>
                                {album.remixer && <>
                                    <div className="field-label">Remixer</div>
                                    <div className="field-value-static">{album.remixer}</div>
                                </>}
                                <div className="field-label">BPM</div>
                                <div className="field-value-static">{album.bpm}</div>
                                <div className="field-label">Uploaded at</div>
                                <div className="field-value-static">{new Date(album.created_at).toLocaleDateString()}</div>
                            </div>
                        }} />
                    </PlatformRenderer>
                    <PlatformRenderer only={'create'}>
                        <Statisic key={9} renderContent={() => {
                            if (!this.state.album) {
                                return <Loader white />
                            }
                            const { album } = this.state as { album: { pack: SoundPackage, tagCount: number } }
                            return <div className='statistic-info-container'>
                                <div className="field-label">Name</div>
                                <div className="field-value-static">{album.pack.name}</div>
                                <div className="field-label">Artist</div>
                                <div className="field-value-static">{album.pack.artist}</div>
                                <div className="field-label">Genre</div>
                                <div className="field-value-static">{album.pack.Genre?.name}</div>
                                <div className="field-label">Label</div>
                                <div className="field-value-static">{album.pack.Label?.name}</div>
                                <div className="field-label">Sub Genres</div>
                                <div className="field-value-static">{album.pack.SubGenres?.length}</div>
                                <div className="field-label">Tags</div>
                                <div className="field-value-static">{album.tagCount}</div>
                            </div>
                        }} />
                    </PlatformRenderer>
                    <DownloadStatisticChart key={10} album={this.props.match.params.id} />
                    <StreamStatisticChart key={20} album={this.props.match.params.id} />
                    <Statisic key={70} title='Total Streams' icon={DOWNLOAD} value={this.state.statistics ? this.state.statistics.totalStreams : undefined} />
                    <Statisic key={80} title='Total Downloads' icon={DOWNLOAD} value={this.state.statistics ? this.state.statistics.totalDownloads : undefined} />
                    <Statisic key={30} title={`${sp(this.context.platform, { default: 'Media', create: 'Sound' })} Files`} icon={AUDIO} value={this.state.statistics ? this.state.statistics.media : undefined} />
                    <Statisic key={60} title='Users Interacted' icon={DOWNLOAD} value={this.state.statistics ? this.state.statistics.usersInteracted : undefined} />
                    <Statisic key={90} title='Total Users Interacted' icon={DOWNLOAD} value={this.state.statistics ? this.state.statistics.totalUsersInteracted : undefined} />

                </ScrollView>
                {/* <Statisic title='Total Searches' icon={DOWNLOAD} value={this.state.statistics ? this.state.statistics.searches : undefined} />*/}
            </div>
            <div className='charts'>
                <div className='bpm-container'>
                    <div className='row'>
                        <div className='col'>
                            <DownloadChart album={this.props.match.params.id} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <StreamChart album={this.props.match.params.id} />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <TopCountryChart album={this.props.match.params.id} />
                        </div>
                        <div className='col'>
                            <TopStateChart album={this.props.match.params.id} />
                        </div>
                        <div className='col'>
                            <DownloadedFromChart album={this.props.match.params.id} />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    }
}

export class AlbumDashboard extends React.Component {
    render() {
        return <Switch>
            <Route path='/album/:id' component={AlbumInner} />
            <Route render={() => {
                return <Redirect to={'/dashboard'} />
            }} />
        </Switch>
    }
}


// WEBPACK FOOTER //
// ./src/pages/Album/AlbumDashboard.tsx